import React from "react";

/**
 * Official letterhead shown at the top of printed/exported reports.
 * The SMZ (Serikali ya Mapinduzi ya Zanzibar) coat of arms sits above the
 * institution name. `subtitle` lets each report label itself (e.g. the
 * report name and the boundary/period it covers).
 */
export const PrintHeader = ({ subtitle }) => (
  <div
    className="text-center mb-4 pb-3"
    style={{ borderBottom: "2px solid #0ab39c" }}
  >
    <img
      src="assets/images/logo/smz.png"
      alt="SMZ"
      height="80"
      style={{ marginBottom: 8 }}
    />
    <h5 className="mb-0 fw-bold text-uppercase">
      Serikali ya Mapinduzi ya Zanzibar
    </h5>
    <div className="text-muted">Tume ya Mipango Zanzibar — Shehia Register</div>
    {subtitle && <div className="fw-semibold mt-1">{subtitle}</div>}
  </div>
);

export default PrintHeader;
